export enum ServiceType {
  LIVE = 'live',
  OFFLINE = 'offline',
  ALL = 'all'
}
